import PropTypes from 'prop-types';
import FacetCheckboxes from '../attributes/checkboxes/facet_checkboxes';
import FacetCheckbox from '../attributes/checkboxes/facet_checkbox';

const FacetProviders = ({ context, isChildList, items, showMore }) => {
  const others = [];
  const included = [];
  const licensed = [];

  items.forEach((item) => {
    const pool = (() => {
      switch (item.type) {
        case 'included':
          return included;
        case 'licensed':
          return licensed;
        case 'api':
          return included;
        default:
          return others;
      }
    })();

    pool.push(
      <FacetCheckbox context={context} facet={item} showMore={showMore} key={item.id} />
    );
  });

  if (included.length > 0) {
    included.unshift(
      <li className="lp-filter-item" key="included">
        <div className="providers-list-subtitle text-gray-800 font-semibold pt-2 pb-1">
          <span className="mr-1">Included Content</span>
          <i
            className={`lp-icon fa-regular fa-circle-info pool-info`}
            data-toggle="popover"
            data-content="This repository includes content from high-quality sites and comprehensive libraries of professionally evaluated educator reviews of hundreds of thousands of free and open educational resources (OER) from hundreds of source sites across the web. These experienced educator-curators bring trust, order, and context to a wealth of free online Pre-K-12 learning resources so you can easily find what you need. "
            data-html="true"
            data-placement="auto"
            data-trigger="hover"
          />
        </div>
      </li>
    );
  }

  if (licensed.length > 0) {
    licensed.unshift(
      <li className="lp-filter-item" key="licensed">
        <div className="providers-list-subtitle text-gray-800 font-semibold pt-2 pb-1">
          <span className="mr-1">District-Licensed Content</span>
          <i
            className={`lp-icon fa-regular fa-circle-info pool-info`}
            data-toggle="popover"
            data-content="District-licensed content from various publishers is included in this repository. You can freely mix these learning objects with content from other sources when creating unique lesson collections to address diverse learning needs."
            data-html="true"
            data-placement="auto"
            data-trigger="hover"
          />
        </div>
      </li>
    );
  }

  return (
    <FacetCheckboxes context={context} items={[]} isChildList={isChildList}>
      {others.length > 0 && <div className="providers-list-divider">{others}</div>}
      {included.length > 0 && <div className="providers-list-divider">{included}</div>}
      {licensed.length > 0 && <div className="providers-list-divider">{licensed}</div>}
    </FacetCheckboxes>
  );
};

FacetProviders.propTypes = {
  context: PropTypes.object,
  isChildList: PropTypes.bool,
  items: PropTypes.array,
  showMore: PropTypes.bool
};

export default FacetProviders;
